import {createStore} from 'zustand/vanilla';
import type {IngestSource, Platform} from '@gl/types/ingest.js';

export interface IngestsState {
  ingests: IngestSource[];
  platforms: Platform[];
  addIngest: (source: IngestSource) => void;
  removeIngest: (id: number) => void;
  setIngests: (sources: IngestSource[]) => void;
  clearIngests: () => void;
  updateStatus: (id: number, status: string) => void;
  updateLastSync: (id: number, lastSync: string) => void;
  addPlatform: (platform: Platform) => void;
  setPlatforms: (platforms: Platform[]) => void;
  updatePlatform: (platformType: string, updatedPlatform: Platform) => void;
  removePlatform: (platform: Platform) => void;
  clearPlatforms: () => void;
}

export const ingestsStore = createStore<IngestsState>()(set => ({
  ingests: [],
  platforms: [],

  addIngest: (source: IngestSource) => {
    set(state => ({
      ingests: [...state.ingests, source],
    }));
  },

  removeIngest: (id: number) => {
    set(state => ({
      ingests: state.ingests.filter(ingest => ingest.id !== id),
    }));
  },

  setIngests: (sources: IngestSource[]) => {
    set({ingests: sources});
  },

  clearIngests: () => {
    set({ingests: []});
  },

  updateIngest: (id: number, updatedIngest: IngestSource) => {
    set(state => ({
      ingests: state.ingests.map(ingest =>
        ingest.id === id ? {...ingest, ...updatedIngest} : ingest
      ),
    }));
  },

  updateStatus: (id: number, status: string) => {
    set(state => ({
      ingests: state.ingests.map(ingest =>
        ingest.id === id ? {...ingest, status} : ingest
      ),
    }));
  },

  updateLastSync: (id: number, lastSync: string) => {
    set(state => ({
      ingests: state.ingests.map(ingest =>
        ingest.id === id ? {...ingest, last_sync: lastSync} : ingest
      ),
    }));
  },

  addPlatform: (platform: Platform) => {
    set(state => ({
      platforms: [...state.platforms, platform],
    }));
  },

  setPlatforms: (platforms: Platform[]) => {
    set({platforms});
  },

  updatePlatform: (platformType: string, updatedPlatform: Platform) => {
    set(state => ({
      platforms: state.platforms.map(platform =>
        platform.platform_type === platformType
          ? {...platform, ...updatedPlatform}
          : platform
      ),
    }));
  },

  removePlatform: (platform: Platform) => {
    set(state => ({
      platforms: state.platforms.filter(
        p => p.platform_type !== platform.platform_type
      ),
    }));
  },

  clearPlatforms: () => {
    set({platforms: []});
  },
}));
